import { Component } from '@angular/core';
import { BasicList } from '../../../../classes';
import { BsModalService } from 'ngx-bootstrap';
import { UploadApi } from '../../../../../assets/js/lb-sdk';
import { ActivatedRoute } from '@angular/router';
import { Event } from '../../../../interfaces';
import { finalize } from 'rxjs/operators';
import { COMMISSION_UPLOAD_STATUS, PAYMENT_METHOD } from '../../../../enums';
import { CommissionUploadApi } from '../../../../../assets/js/lb-sdk/services/custom/CommissionUpload';
import { ProductsService } from '../../../../services';

@Component({
  selector: 'app-commission-upload',
  templateUrl: './commission-upload.component.html',
  styleUrls: ['./commission-upload.component.css']
})
export class CommissionUploadComponent extends BasicList {
  COMMISSION_UPLOAD_STATUS: typeof COMMISSION_UPLOAD_STATUS = COMMISSION_UPLOAD_STATUS;
  commissionUpload;
  searchSettings;

  constructor(
    public commissionUploadApi: CommissionUploadApi,
    private uploadApi: UploadApi,
    private modalService: BsModalService,
    private route: ActivatedRoute,
    private productService: ProductsService
  ) {
    super();
    this.searchSettings = {
      searchFields: [],
      searchableFields: [
        { name: 'reference', placeholder: 'Reference Number' },
        { name: 'username', placeholder: 'Username' },
        { name: 'paymentMethod', placeholder: 'Payment Method', options: PAYMENT_METHOD },
        { name: 'orderId', placeholder: 'Order Id' },
        { name: 'orderItemId', placeholder: 'Order Item Id' },
        { name: 'productType', placeholder: 'Product Type', optionsFunction: () => {
          return (this.productService.getProductTypes() || [])
            .map(productType => {
              return {
                value: productType.name,
                description: productType.description
              };
            });
        } },
        { name: 'status', placeholder: 'Status', options: COMMISSION_UPLOAD_STATUS }
      ],
      filters: {}
    };
    this.searchSettings.searchFields.push(this.searchSettings.searchableFields[0]);
    this.route.paramMap
      .subscribe((params: any) => {
        this.params = {
          where: {
            uploadId: params.params.id
          },
          order: 'orderIndex ASC'
        };
      });
    this.settings = {
      createComponent: undefined,
      api: this.commissionUploadApi,
      ModalService: this.modalService
    };
    this.pagination = {
      page: 1,
      limit: 100,
      total: 0
    };
  }

  eventListener(event: Event) {
    switch (event.event) {
      case 'initialized':
        this.loading.commissionUpload = true;
        this.clearErrors();
        this.uploadApi
          .findById(this.params.where.uploadId)
          .pipe(finalize(() => {
            this.loading.commissionUpload = false;
          }))
          .subscribe(
            commissionUpload => {
              this.commissionUpload = commissionUpload;
            },
            error => {
              this.errors.commissionUpload = error.message || 'Failed to load bank transaction details';
            }
          );
        this.getList();
        break;
    }
  }
}
